import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminLogin, setAdminToken, getAdminToken } from "@/lib/api";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (getAdminToken()) navigate("/admin", { replace: true });
    }, [navigate]);

    async function onSubmit(e) {
        e.preventDefault();
        setSubmitting(true);
        try {
            const res = await adminLogin({ email, password });
            setAdminToken(res.access_token);
            toast.success("Signed in.");
            navigate("/admin", { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div
            data-testid="admin-login-page"
            className="mx-auto max-w-md px-4 py-24"
        >
            <div className="card-surface p-8">
                <h1 className="font-display text-3xl font-extrabold text-[color:var(--brand-navy)]">
                    Admin sign in
                </h1>
                <p className="mt-2 text-sm text-slate-600">
                    Private access for Central Florida Mobility Rentals staff.
                </p>
                <form onSubmit={onSubmit} className="mt-6 grid gap-4">
                    <div>
                        <Label className="mb-2 block text-sm font-semibold text-slate-800">
                            Email
                        </Label>
                        <Input
                            data-testid="admin-email-input"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="h-12 rounded-xl"
                        />
                    </div>
                    <div>
                        <Label className="mb-2 block text-sm font-semibold text-slate-800">
                            Password
                        </Label>
                        <Input
                            data-testid="admin-password-input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="h-12 rounded-xl"
                        />
                    </div>
                    <button
                        type="submit"
                        data-testid="admin-login-submit"
                        disabled={submitting}
                        className="hero-cta pill-btn mt-2 inline-flex w-full items-center justify-center gap-2 text-white disabled:opacity-60"
                    >
                        {submitting && <Loader2 className="h-4 w-4 animate-spin" />}
                        Sign in
                    </button>
                </form>
                <Link
                    to="/"
                    className="mt-6 block text-center text-sm text-slate-500 hover:text-[color:var(--brand-navy)]"
                >
                    ← Back to home
                </Link>
            </div>
        </div>
    );
}
